import React, { useState } from "react";
import {
  Button,
  TextField,
  CircularProgress,
  Typography,
  Modal,
  Backdrop,
  Fade,
  Box,
} from "@mui/material";
// import Logo from "../../assets/logo.png";
import useStyles from "../../../globalStyles";
import { primaryColor, secondaryColor } from "../../../constants/colors";
import AuthBackground from "../../../components/authBackground";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import ReactCodeInput from "react-code-input";
import "./style.css";
import axios from "axios";
import { sendCode, forgotPassword } from "../../../services/restaurant";
import Loader from "../../../components/loader";
import SnackbarAlert from "../../../components/snackbar/SnackbarAlert";

const ForgotPassword = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleLogin = () => {
    let payload = {
      email,
    };
    if (email == "") {
      handleSnackbarVal(true, "error", "Email is required");
    } else {
      return
      setIsLoading(true);
      sendCode(payload)
        .then((response) => {
          console.log(response.data, "respppppppppp");
          if (response.data.status == "error") {
            setIsLoading(false);
            handleSnackbarVal(
              true,
              "error",
              response.data.message
                ? response.data.message
                : "something went wrong"
            );
          } else {
            setIsLoading(false);
            handleSnackbarVal(true, "success", response.data.message);
            setOpen(true);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error.data, "erooooo=>");
        });
    }
  };

  const handleforgotPassword = () => {
    setIsLoading(true);
    let payload = {
      email,
      otp: code,
      password,
    };
    forgotPassword(payload)
      .then((response) => {
        console.log(response.data, "response========>");
        if (response.data.status == "error") {
          setIsLoading(false);
          handleSnackbarVal(
            true,
            "error",
            response.data.message
              ? response.data.message
              : "something went wrong"
          );
        } else {
          setIsLoading(false);
          handleSnackbarVal(true, "success", response.data.message);
          setOpen(false);
          setEmail("");
          setCode("");
          setPassword("");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setOpen(false);
        console.log(error.datam, "error");
      });
  };
  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: "0 0.2rem 1rem rgb(0 0 0 / 12%)",
    p: 4,
    textAlign: "center",
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  return (
    <>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <AuthBackground>
        <div className={classes.paper}>
          <Typography style={{ fontSize: "25px", fontWeight: "600" }}>
            Forgot Password ?
          </Typography>
          <Typography style={{ fontWeight: "500" }}>
            We are sending a code to your email
          </Typography>
          <TextField
            variant='outlined'
            margin='normal'
            required={true}
            id='email'
            placeholder='Email'
            name='email'
            autoComplete='email'
            autoFocus
            className={classes.globalInput}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            onKeyPress={(e) => (e.key == "Enter" ? handleLogin() : null)}
          />

          <div
            style={{ margin: "10px 0", display: "flex", alignItems: "center" }}
          >
            <ArrowBack
              style={{
                color: secondaryColor,
                fontSize: "18px",
                cursor: "pointer",
              }}
            />
            <Typography
              onClick={() => navigate("/login")}
              style={{ color: secondaryColor, cursor: "pointer" }}
            >
              Back to login
            </Typography>
          </div>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Button
              variant='contained'
              className={classes.loginBtn}
              size='small'
              onClick={handleLogin}
              disableRipple
            >
              <Typography className={classes.loginBtnText}>
                Send Code
              </Typography>
            </Button>
          </div>
        </div>
      </AuthBackground>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography style={{ fontSize: "23px", fontWeight: "600" }}>
              Verify code to reset your password
            </Typography>
            <div className='code-input'>
              <ReactCodeInput
                type='text'
                fields={4}
                value={code}
                onChange={(code) => setCode(code)}
              />
            </div>
            <TextField
              variant='outlined'
              margin='normal'
              required={true}
              id='password'
              placeholder='Password'
              name='password'
              autoComplete='password'
              autoFocus
              className={classes.globalInput}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              onKeyPress={(e) => (e.key == "Enter" ? handleLogin() : null)}
            />
            <Button
              variant='contained'
              className={classes.loginBtn}
              size='small'
              onClick={handleforgotPassword}
              disableRipple
              style={{ width: "80%" }}
            >
              <Typography className={classes.loginBtnText}>Confirm</Typography>
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default ForgotPassword;
